import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../../config/apiConfig";
import { getAdminEmail } from "../../utils/auth";

const ProfilePage = () => {
  const [admin, setAdmin] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    username: "",
    password: "",
  });

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const email = getAdminEmail();
        if (!email) {
          alert("Please refresh the page before proceeding!");
          return;
        }

        const response = await axios.post(`${BASE_URL}/api/admin/admin`, {
          email,
        });
        setAdmin(response.data);

        setFormData({
          email: response.data.email,
          username: response.data.username,
          password: "", // Exclude password for security
        });
      } catch (error) {
        console.error("Error fetching admin data:", error);
      }
    };

    fetchAdmin();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    try {
      const response = await axios.put(
        `${BASE_URL}/api/admin/update/${admin.id}`,
        formData
      );
      // Update admin state directly to reflect changes immediately
      setAdmin((prevAdmin) => ({
        ...prevAdmin,
        email: formData.email,
        username: formData.username,
      }));
      setEditMode(false);
      alert("Profile updated successfully!");
    } catch (error) {
      console.error("Error updating admin data:", error);
      alert("Error updating profile. Please try again later.");
    }
  };

  if (!admin) return <div>Loading...</div>;

  return (
    <div className="profile-container">
      <header className="profile-header">
        <div className="profile-header-top">
          <div className="profile-picture">
            <img src="/Images/defaultProfileDp.png" alt="Profile" />
            <button
              className="edit-btn"
              onClick={() => setEditMode((prev) => !prev)}
            >
              {editMode ? "Cancel" : "Edit"}
            </button>
          </div>
          <div className="profile-details">
            <h1>Welcome, {admin.username}</h1>
            {/* <p>
              <strong>Email:</strong> {admin.email}
            </p> */}
            <p>
              <strong>Joined On:</strong>{" "}
              {new Date(admin.created_at).toLocaleDateString()}
            </p>
          </div>
        </div>
      </header>

      <section className="profile-section">
        <h2>Profile Information</h2>
        {editMode ? (
          <form className="profile-form">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
              />
            </div>
            <button type="button" className="save-btn" onClick={handleUpdate}>
              Save Changes
            </button>
          </form>
        ) : (
          <>
            <p>
              <strong>Username:</strong> {admin.username}
            </p>
            <p>
              <strong>Email:</strong> {admin.email}
            </p>
          </>
        )}
      </section>
    </div>
  );
};

export default ProfilePage;


